<template>
  <div>
    <div id="pageTable">
      <v-container fluid>
        <v-layout row wrap>
          <v-flex lg12>
            <v-card>
              <v-toolbar card color="white">
                <v-text-field
                  flat
                  hide-details
                  :placeholder="$t('search')"
                  prepend-icon="search"
                  solo
                  v-model="search"
                ></v-text-field>
                <v-btn
                  v-if="can('create', 'aspect')"
                  small
                  color="primary"
                  @click="sendEmit('create')"
                >{{$t('new')}}</v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text class="text-xs-center pa-0">
                <v-data-table
                  :headers="complex.headers"
                  :items="formatList"
                  :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                  :search="search"
                  class="elevation-1"
                  item-key="_id"
                  :loading="loading"
                  :pagination.sync="pagination"
                >
                  <template slot="items" slot-scope="props">
                    <td class="justify-center px-0">
                      <v-btn v-if="can('edit', 'aspect',  props.item)" flat icon color="success">
                        <v-icon
                          class="icon material-icons"
                          @click="sendEmit('update', props.item._id)"
                        >create</v-icon>
                      </v-btn>
                      <v-btn v-if="can('delete', 'aspect',  props.item)" flat icon color="error">
                        <v-icon
                          class="icon material-icons"
                          @click="sendEmit('delete', props.item._id)"
                        >delete</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <i
                        class="success--text icon material-icons"
                        v-if="props.item.active"
                      >check_circle</i>
                      <i class="error--text icon material-icons" v-else>cancel</i>
                    </td>
                    <!--<td>{{formatLanguage(props.item.name, '5bd9f3ee7fa5610014fed21e') }}</td>-->
                    <td style="min-width:400px">{{props.item.name}}</td>
                    <td>{{props.item.type}}</td>
                    <td>{{props.item.typeScore}}</td>
                    <td>{{props.item.untilSelect}}</td>
                    <td>{{props.item.createdAt}}</td>
                    <td>{{props.item.createdBy}}</td>
                    <td>{{props.item.updatedAt}}</td>
                    <td>{{props.item.updatedBy }}</td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { dateFormat } from '../../../helpers/dateHelper'
export default {
  name: 'list',
  data() {
    return {
      search: '',
      pagination: {
        sortBy: 'active',
        descending: true
      },
      complex: {
        headers: [
          {
            text: this.$t('actions'),
            align: 'center',
            value: ''
          },
          {
            text: this.$t('state'),
            align: 'center',
            value: 'active'
          },
          {
            text: this.$t('name'),
            align: 'center',
            value: 'name'
          },
          {
            text: this.$t('type'),
            align: 'center',
            value: 'type'
          },
          {
            text: this.$t('typeScore'),
            align: 'center',
            value: 'typeScore'
          },
          {
            text: this.$t('untilScore'),
            align: 'center',
            value: 'untilScore'
          },
          {
            text: this.$t('createdAt'),
            align: 'center',
            value: 'createdAt'
          },
          {
            text: this.$t('createdBy'),
            align: 'center',
            value: 'createdBy'
          },
          {
            text: this.$t('updatedAt'),
            align: 'center',
            value: 'updatedAt'
          },
          {
            text: this.$t('updatedBy'),
            align: 'center',
            value: 'updatedBy'
          }
        ]
      }
    }
  },
  mounted() {},
  computed: {
    ...mapState({
      aspectList: state => state.aspects.list,
      loading: state => state.entities.loading
    }),
    formatList() {
      return this.aspectList.map(aspect => {
        return {
          ...aspect,
          type: this.$t('types.' + aspect.type),
          untilSelect: aspect.untilSelect || '-',
          typeScore: this.$t(aspect.typeScore, { field: '' }),
          createdAt: dateFormat(aspect.createdAt, false),
          updatedAt: dateFormat(aspect.updatedAt, false)
        }
      })
    }
  },
  methods: {
    ...mapActions({
      getOne: 'aspects/setOne'
    }),
    dateFormat(value) {
      return dateFormat(value, false)
    },
    sendEmit(evento, id = null) {
      if (
        evento !== 'delete' &&
        evento !== 'create' &&
        evento !== 'update' &&
        evento !== 'view'
      ) {
        return
      }
      switch (evento) {
        case 'create':
          this.$emit('create')
          break
        case 'update':
          this.getOne(id).then(_ => {
            this.$emit('update')
          })
          break
        case 'delete':
          this.getOne(id).then(_ => {
            this.$emit('remove')
          })
          break
        case 'view':
          this.getOne(id).then(_ => {
            this.$emit('view')
          })
          break
      }
    },
    formatLanguage(text, idLanguage) {
      let item = text.find(item => item.langId === idLanguage)
      return item ? item.text : '*'
    }
  }
}
</script>
<style scoped>
.cursor {
  cursor: pointer;
}

.line-bottom {
  border-bottom: 1px solid #000;
}

.text-left {
  text-align: left;
}

.success--text {
  color: green;
}

.error--text {
  color: red;
}
</style>
